import React, { Component } from "react";
import { TextField } from "reactackle";
import { isMobile } from "react-device-detect";
import "./photo.css";
import _ from "lodash";
import { compose } from "recompose";
import { withFirebase } from "../../../Firebase";
import { connect } from "react-redux";
import { v1 as uuidv1 } from "uuid";

class PhotoUploadPass extends Component {
  getImages = () => {
    if (this.props.images && this.props.images.length > 0) {
      // console.log(
      //   "babu sending normal image: " + JSON.stringify(this.props.images)
      // );
      return this.props.images.map((imgData, index) => {
        // console.log(
        //   "babu chota image: " + imgData.url + " " + JSON.stringify(imgData)
        // );
        if (
          imgData.action !== "REMOVE" &&
          imgData.b64 !== "" &&
          imgData.b64.length > 0
        ) {
          return (
            <div
              className="img"
              style={{
                backgroundImage:
                  imgData.b64 !== "" ? "url(" + imgData.b64 + ")" : "",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                maxWidth: "150px",
                border: "1px solid gainsboro"
              }}
              onClick={() => {
                this.props.stateChangeHandler([], this.props.fieldName, false);
              }}
            >
              <span
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  color: "red"
                }}
              >
                <i
                  className="fa fa-times-circle fa-lg"
                  style={{ backgroundColor: "white" }}
                />
              </span>
            </div>
          );
        } else {
          console.log("babu didnt send back anything");
        }
      });
    }
  };

  uploadImage = evtFiles => {
    try {
      //console.log("triggering inside uploadImage function");
      let imageName = uuidv1() + ".jpg";
      const Compress = require("compress.js");
      const compress = new Compress();
      const files = [...evtFiles];
      compress
        .compress(files, {
          size: 1, // the max size in MB, defaults to 2MB
          quality: 1, // the quality of the image, max is 1,
          maxWidth: 800, // the max width of the output image, defaults to 1920px
          maxHeight: 800, // the max height of the output image, defaults to 1920px
          resize: true // defaults to true, set false if you do not want to resize the image width and height
        })
        .then(data => {
          //console.log("after conversion: " + JSON.stringify(data));
          let imgArray = [];
          let stateImgArray = [];

          stateImgArray.push({
            status: "UPLOADING...",
            imageName: imageName,
            url: "",
            b64: "data:image/png;base64," + data[0].data
          });

          this.props.stateChangeHandler(
            stateImgArray,
            this.props.fieldName,
            false
          );
          if (stateImgArray !== undefined && stateImgArray !== "") {
            if (this.props.nextStage && this.props.nextStage !== "") {
              this.props.stateChangeHandler(
                this.props.nextStage,
                "stage",
                false
              );
              this.props.setScroll(true);
            }
          }
        });
    } catch (err) {
      alert(err);
    }
  };

  render() {
    return (
      <div
        style={{
          margin: "5px",
          marginBottom: "15px",
          borderRadius: "5px",
          backgroundColor: "white"
        }}
      >
        <table
          className="table"
          style={{
            marginBottom: "-10px"
          }}
        >
          <tbody>
            <tr>
              <td style={{ width: "100px" }}>
                {!this.props.disabled && (
                  <label
                    for={"uploader" + this.props.fieldName}
                    style={{
                      padding: "1px",
                      textAlign: "center",
                      border: "1px solid gainsboro",
                      borderRadius: isMobile ? "5px" : "0px",
                      backgroundColor: "rgb(30, 101, 144)",
                      margin: "5px",
                      padding: "6px",
                      fontWeight: "bold",
                      color: "white",
                      fontSize: "12px"
                    }}
                  >
                    <div>
                      <i className="fa fa-plus"></i> UPLOAD
                    </div>
                  </label>
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                {!this.props.disabled &&
                  this.props.images &&
                  this.props.images.length > 0 && (
                    <div className="images">{this.getImages()}</div>
                  )}
                {!this.props.disabled &&
                  (!this.props.images || !this.props.images.length > 0) && (
                    <div>
                      <div>{this.props.title1}</div>
                      <div
                        style={{
                          textAlign: "center"
                        }}
                      >
                        {this.props.title2}
                      </div>
                    </div>
                  )}
              </td>
            </tr>
          </tbody>
        </table>

        <input
          type="file"
          accept="image/*"
          id={"uploader" + this.props.fieldName}
          onChange={evt => {
            console.log("clicked");
            //console.log("triggering main function");
            event.preventDefault();

            if (evt.target.files[0]) {
              this.uploadImage(evt.target.files);
            } else {
              console.log("gotcha");
            }
          }}
          style={{
            visibility: "hidden"
          }}
        />
      </div>
    );
  }
}

export default compose(
  connect(
    null,
    null
  ),
  withFirebase
)(PhotoUploadPass);



// WEBPACK FOOTER //
// ./src/app/components/Screens/FieldsComponents/PhotoUpload/PhotoUploadPass.jsx